import React, { useState, useEffect } from 'react';
import { config } from '../../../config';
import { handleResponse } from '../../../helpers/response';
import { Link } from 'react-router-dom';
import i18n from 'i18next';
import ProductsList from '../../productsList';
import ListGoods from '../../listGoods';
import Filters from '../../filters';
import CategoriesPanel from '../../sub/CategoriesPanel';
import { connect } from 'react-redux';
import Footer from '../../footer';
import { Helmet } from 'react-helmet';

const WrapperProductList = (props) => {
  const alias = props.match.params.alias;
  const categoryFilter = props.match.params.categoryFilter;

  const [queryString, setQueryString] = useState('');

  /**
   * merge search url and url from api via alias (f5 bug )
   *
   * @param filtersString
   * @param filterFromAlias
   * @returns {*}
   */
  const createSearchLink = (filtersString, filterFromAlias) => {
    const urlSearchParams = new URLSearchParams(filtersString);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.filter !== undefined) {
      let filters = [];
      filters = params.filter.split(' ');
      if (Object.keys(filters).length > 0) {
        console.log('filters ', filters);
        console.log('filterFromAlias ', filterFromAlias);
        filters.push(filterFromAlias);
        filters = filters.filter((x, i, a) => a.indexOf(x) == i);
        urlSearchParams.set('filter', filters);
      }
    } else {
      urlSearchParams.set('filter', filterFromAlias);
    }
    return urlSearchParams.toString().replaceAll('%2C', '+');
  };

  useEffect(() => {
    const link = `${config.apiUrl}api/convert/custommenu/${alias}`;
    fetch(link, { method: 'GET' })
      .then(handleResponse)
      .then((json) => {
        console.log('json', json);
        const filterLink =
          '?' + createSearchLink(props.location.search, json.query);
        console.log('filter link ', filterLink);
        setQueryString(filterLink);
      })
      .catch((error) => {
        alert('error');
      });
  }, [props.location.search]);

  return (
    <div>
      <header>
        <Helmet>
          <title>{i18n.t('brand.title')}</title>
        </Helmet>
      </header>
      {console.log('filters url', queryString)}
      {console.log('categoryFilter', categoryFilter)}
      {queryString !== '' && (
        <div className='main-container uk-container  uk-flex uk-flex-wrap'>
          <div className='filter uk-width-1-3@m uk-width-1-5@l uk-width-1-1 uk-visible@m'>
            <CategoriesPanel
              categoriesPanel={props.categoriesPanel}
              location={props.location}
              linkPatternRender={`/products/${i18n.language}/custom/${alias}/%categoryFilter%`}
            />
            {categoryFilter && (
              <Filters
                filtersUrl={queryString}
                location={props.location}
                category={categoryFilter}
                isRequest={true}
                history={props.history}
              />
            )}
          </div>
          <div className='products-view uk-width-2-3@m uk-width-4-5@l  uk-width-1-1 uk-position-relative'>
            <ListGoods
              history={props.history}
              categoryData={categoryFilter}
              filtersUrl={queryString}
            />
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

const mapStateToProps = (store) => {
  const { dataFilters } = store.goods;
  console.log('list gooooods ');
  return {
    dataFilters,
    categoriesPanel: store.goods.listGoods.categoriesProduct,
  };
};

export default connect(mapStateToProps)(WrapperProductList);
